















import Vue from 'vue'

import RoleList from './RoleList.vue'
import RoleUser from './RoleUser.vue'
import RolePermission from './components/RolePermission'

export default Vue.extend({
  name: 'role-management',
  components: {
    RoleList,
    RoleUser,
    RolePermission,
  },
  filters: {},
  data() {
    return {
      roleName: '',
      roleId: '',
    }
  },
  methods: {
    roleChange({ name, id }) {
      this.roleName = name
      this.roleId = id
    },
  },
})
